import { Box, Paper, Stack } from "@mui/material";
import { styled } from "@mui/material/styles";
import { HeadingL, HeadingXL, HelpBox } from "@repo/ui";

export const MobileLoadingCardsRow = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        flexDirection: "row",
        gap: 6,
        pl: 4,
    }),
);

export const MobileContractStateBox = styled(Box, {
    shouldForwardProp: (prop) => prop !== "isErrored",
})<{ isErrored: boolean }>(({ theme, isErrored }) =>
    theme.unstable_sx({
        flexGrow: 1,
        opacity: isErrored ? 0.5 : 1,
        pointerEvents: isErrored ? "none" : "auto",
    }),
);

export const FufiMobileHeaderPaper = styled(Paper)(({ theme }) =>
    theme.unstable_sx({
        flexGrow: 1,
        alignSelf: "stretch",
        p: 4,
    }),
);

export const ContractsListLayout = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        flexDirection: { xs: "column", md: "row" },
        justifyContent: { md: "space-between" },
    }),
);

export const ContractsSelectorColumn = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        flexShrink: { md: 0 },
        width: { md: "50%" },
        pt: { md: 2, xs: 0 },
    }),
);

export const DesktopHelpBox = styled(HelpBox)(({ theme }) =>
    theme.unstable_sx({
        display: "flex",
    }),
);

export const ContractsDetailColumn = styled(Box)(({ theme }) =>
    theme.unstable_sx({
        width: { md: "48.3%" },
    }),
);

export const DesktopDashboardLayout = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        gap: 5,
    }),
);

export const DesktopPageTitle = styled(HeadingXL)(({ theme }) =>
    theme.unstable_sx({
        mb: 0,
    }),
);

export const MobileDashboardLayout = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        justifyContent: "space-between",
    }),
);

export const MobileDashboardContent = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        gap: { xs: 5, md: 7 },
    }),
);

export const MobilePageTitle = styled(HeadingL)(({ theme }) =>
    theme.unstable_sx({
        mb: 0,
        pl: { md: 0, xs: 4 },
    }),
);

export const MobileNightRunWrapper = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        pb: 8,
    }),
);

export const mobileContractsSnapperSx = {
    alignItems: "stretch",
    pb: 4,
};

export const mobileContractsChildContainerProps = {
    sx: {
        p: 1,
        display: "flex",
        alignItems: "stretch",
    },
};

export const detailSnapperSx = {
    my: 0,
    mx: 3,
};

export const detailChildContainerProps = {
    sx: {
        py: 1,
        px: 3,
    },
};